/**
* Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      // Grabs each answer div and several children within,
      const answers = document.querySelectorAll( '.accordion__panel' );
      const answerParagraph = document.querySelectorAll( '.accordion__panel .wysiwyg' );
      const svg = document.querySelectorAll( '.faqs .icon-plus' );

      // Loops through each answer when a question is clicked in order
      // to grab the exact height of the content for smooth, variable max height.
      document.querySelectorAll( '.accordion__header' ).forEach( function( el, idx ) {
        el.addEventListener( 'click', function() {
          removeHeight();
          if ( answers[idx].classList.contains( 'active' ) ) {
            const wHeight = answerParagraph[idx].clientHeight;
            answers[idx].style.height = wHeight + 'px';
            answers[idx].parentNode.parentNode.classList.add( 'active' );
          } else {
            answers[idx].style.height = 0;
            answers[idx].parentNode.parentNode.classList.remove( 'active' );
          }
        } );
      } );

      function removeHeight() {
        answers.forEach( function( el, idx ) {
          if ( !$( this ).hasClass( 'active' ) ) {
            answers[idx].style.height = 0;
            answers[idx].parentNode.parentNode.classList.remove( 'active' );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'accordion', COMPONENT );
} )( app );
